import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import { IPaginatedListOfComponentTemplateDto } from "@growth-machine-llc/stridist-api-client";
import { COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY } from "../ComponentTemplateLibrary";
import { useQueryClient } from "@tanstack/react-query";
import { COMPONENT_TEMPLATES_LIST_QUERY_KEY } from "../../component-template/ComponentTemplateDialog";
import { ComponentStatus } from "../../../constants";
import ComponentsService from "../../../services/ComponentsService";

export const useRestoreLibraryComponentTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    successToastMessage: "Template restored",
    queryKey: [
      COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY,
      { status: ComponentStatus.ARCHIVED },
    ],
    mutationFn: ComponentsService.restoreComponentTemplate,
    optimisticUpdater: {
      updateFn: (oldData: IPaginatedListOfComponentTemplateDto, id) => {
        return {
          ...oldData,
          items: oldData.items.filter((item) => item.id !== id),
        };
      },
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
    exactQueryKey: false,
    options: {
      onSuccess() {
        queryClient.invalidateQueries({
          queryKey: [
            COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY,
            {
              status: ComponentStatus.PUBLISHED,
            },
          ],
        });
        queryClient.invalidateQueries({
          queryKey: [COMPONENT_TEMPLATES_LIST_QUERY_KEY],
        });
      },
    },
  });
};
